// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  --image-shell-loading-background: #EEE;
  --image-shell-border-radius: 0px;
  --image-shell-color: #333;
  display: block;
  position: relative;
  height: 100%;
  border-radius: var(--image-shell-border-radius);
  transition: all ease-in-out 0.3s;
  z-index: 2;
}
:host > .spinner {
  display: none;
}
:host::before {
  content: "";
  background: var(--image-shell-loading-background);
  border-radius: var(--image-shell-border-radius);
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
:host:not([display=cover]) {
  width: 100%;
  overflow: hidden;
}
:host:not([display=cover]) > .inner-img {
  transition: visibility 0s linear, opacity 0.5s linear;
  opacity: 0;
  visibility: hidden;
  width: 100%;
  height: 100%;
  border-radius: var(--image-shell-border-radius);
  display: block;
}
:host:not([display=cover]).img-ssr::before, :host:not([display=cover]).img-loaded::before {
  display: none;
}
:host:not([display=cover]).img-ssr > .inner-img, :host:not([display=cover]).img-loaded > .inner-img {
  opacity: 1;
  visibility: visible;
}
:host:not([display=cover]).img-error > .inner-img {
  color: var(--image-shell-color);
  font-size: 12px;
}
:host:not([display=cover]).img-error::after {
  content: attr(data-error);
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 10px;
  color: var(--image-shell-color);
  background-color: var(--image-shell-loading-background);
  font-size: 12px;
}
:host[display=cover] {
  background-size: cover;
  background-repeat: no-repeat;
}
:host[display=cover]::before, :host[display=cover] > .spinner {
  z-index: -1;
}
:host[display=cover] > .inner-img {
  display: none;
  visibility: hidden;
}
:host[display=cover].img-ssr::before, :host[display=cover].img-loaded::before {
  display: none;
}

:host([animation=gradient]) {
  --image-shell-loading-background: #EEE;
  --image-shell-animation-color: #DDD;
}
:host([animation=gradient])::before {
  background: linear-gradient(to right, var(--image-shell-loading-background) 8%, var(--image-shell-animation-color) 18%, var(--image-shell-loading-background) 33%);
  background-size: 800px 104px;
  animation: animateBackground 2s ease-in-out infinite;
}
:host([animation=gradient]).img-ssr::before, :host([animation=gradient]).img-loaded::before, :host([animation=gradient]).img-error::before {
  background: none;
  animation: 0;
}
@keyframes animateBackground {
  0% {
    background-position: -468px 0;
  }
  100% {
    background-position: 468px 0;
  }
}

:host([animation=spinner]) {
  --image-shell-spinner-size: 28px;
  --image-shell-spinner-color: #CCC;
}
:host([animation=spinner]) > .spinner {
  display: block;
  position: absolute;
  top: calc(50% - var(--image-shell-spinner-size) / 2);
  left: calc(50% - var(--image-shell-spinner-size) / 2);
  width: var(--image-shell-spinner-size);
  height: var(--image-shell-spinner-size);
  font-size: var(--image-shell-spinner-size);
  line-height: var(--image-shell-spinner-size);
  color: var(--image-shell-spinner-color);
}
:host([animation=spinner]).img-ssr > .spinner, :host([animation=spinner]).img-loaded > .spinner, :host([animation=spinner]).img-error > .spinner {
  display: none;
  visibility: hidden;
}

:host(.add-overlay) {
  --image-shell-overlay-background: rgba(0, 0, 0, .4);
}
:host(.add-overlay).img-ssr::before, :host(.add-overlay).img-loaded::before, :host(.add-overlay).img-error::before {
  display: block;
  background: var(--image-shell-overlay-background);
}`, "",{"version":3,"sources":["webpack://./src/app/components/shell/image-shell/image-shell.component.scss"],"names":[],"mappings":"AAAA;EACE,sCAAA;EACA,gCAAA;EACA,yBAAA;EAEA,cAAA;EACA,kBAAA;EACA,YAAA;EACA,+CAAA;EACA,gCAAA;EACA,UAAA;AAAF;AAGE;EACE,aAAA;AADJ;AAKE;EACE,WAAA;EACA,iDAAA;EACA,+CAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;AAHJ;AAME;EACE,WAAA;EACA,gBAAA;AAJJ;AAMI;EACE,qDAAA;EACA,UAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,+CAAA;EAEA,cAAA;AALN;AAWM;EACE,aAAA;AATR;AAYM;EACE,UAAA;EACA,mBAAA;AAVR;AAeM;EAEE,+BAAA;EACA,eAAA;AAdR;AAkBM;EACE,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,aAAA;EACA,+BAAA;EACA,uDAAA;EACA,eAAA;AAhBR;AAuBE;EACE,sBAAA;EACA,4BAAA;AArBJ;AAwBI;EAEE,WAAA;AAvBN;AA0BI;EACE,aAAA;EACA,kBAAA;AAxBN;AA8BM;EACE,aAAA;AA5BR;;AAkCA;EACE,sCAAA;EACA,mCAAA;AA/BF;AAkCE;EACE,kKACE;EACF,4BAAA;EACA,oDAAA;AAjCJ;AAwCI;EACE,gBAAA;EACA,YAAA;AAtCN;AA0CE;EACE;IACE,6BAAA;EAxCJ;EA2CE;IACE,4BAAA;EAzCJ;AACF;;AA6CA;EACE,gCAAA;EACA,iCAAA;AA1CF;AA4CE;EACE,cAAA;EACA,kBAAA;EACA,oDAAA;EACA,qDAAA;EACA,sCAAA;EACA,uCAAA;EACA,0CAAA;EACA,4CAAA;EACA,uCAAA;AA1CJ;AAgDI;EACE,aAAA;EACA,kBAAA;AA9CN;;AAmDA;EACE,mDAAA;AAhDF;AAsDI;EACE,cAAA;EACA,iDAAA;AApDN","sourcesContent":[":host {\r\n  --image-shell-loading-background: #EEE;\r\n  --image-shell-border-radius: 0px;\r\n  --image-shell-color: #333;\r\n\r\n  display: block;\r\n  position: relative;\r\n  height: 100%;\r\n  border-radius: var(--image-shell-border-radius);\r\n  transition: all ease-in-out .3s;\r\n  z-index: 2;\r\n\r\n  // By default, hide the spinner\r\n  & > .spinner {\r\n    display: none;\r\n  }\r\n\r\n  // Loading background\r\n  &::before {\r\n    content: '';\r\n    background: var(--image-shell-loading-background);\r\n    border-radius: var(--image-shell-border-radius);\r\n    position: absolute;\r\n    top: 0;\r\n    bottom: 0;\r\n    left: 0;\r\n    right: 0;\r\n  }\r\n\r\n  &:not([display=\"cover\"]) {\r\n    width: 100%;\r\n    overflow: hidden;\r\n\r\n    & > .inner-img {\r\n      transition: visibility 0s linear, opacity .5s linear;\r\n      opacity: 0;\r\n      visibility: hidden;\r\n      width: 100%;\r\n      height: 100%;\r\n      border-radius: var(--image-shell-border-radius);\r\n      // Image should fill the space while loading\r\n      display: block;\r\n    }\r\n\r\n    &.img-ssr,\r\n    &.img-loaded {\r\n      // Hide loading background once the image has loaded\r\n      &::before {\r\n        display: none;\r\n      }\r\n\r\n      & > .inner-img {\r\n        opacity: 1;\r\n        visibility: visible;\r\n      }\r\n    }\r\n\r\n    &.img-error {\r\n      & > .inner-img {\r\n        // For the Alt text\r\n        color: var(--image-shell-color);\r\n        font-size: 12px;\r\n      }\r\n\r\n      // Add placeholder background\r\n      &::after {\r\n        content: attr(data-error);\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n        position: absolute;\r\n        top: 0;\r\n        width: 100%;\r\n        height: 100%;\r\n        box-sizing: border-box;\r\n        padding: 10px;\r\n        color: var(--image-shell-color);\r\n        background-color: var(--image-shell-loading-background);\r\n        font-size: 12px;\r\n      }\r\n    }\r\n  }\r\n\r\n  // * NOTE: we didn't add .img-error styles for 'cover' display on purpose.\r\n  // If it is display: cover\r\n  &[display=\"cover\"] {\r\n    background-size: cover;\r\n    background-repeat: no-repeat;\r\n\r\n    // In cover display, we can have content inside the element, thus we need to put these elements beneath\r\n    &::before,\r\n    & > .spinner {\r\n      z-index: -1;\r\n    }\r\n\r\n    & > .inner-img {\r\n      display: none;\r\n      visibility: hidden;\r\n    }\r\n\r\n    &.img-ssr,\r\n    &.img-loaded {\r\n      // Hide loading background once the image has loaded\r\n      &::before {\r\n        display: none;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n:host([animation=\"gradient\"]) {\r\n  --image-shell-loading-background: #EEE;\r\n  --image-shell-animation-color: #DDD;\r\n\r\n  // The animation that goes beneath the masks\r\n  &::before {\r\n    background:\r\n      linear-gradient(to right, var(--image-shell-loading-background) 8%, var(--image-shell-animation-color) 18%, var(--image-shell-loading-background) 33%);\r\n    background-size: 800px 104px;\r\n    animation: animateBackground 2s ease-in-out infinite;\r\n  }\r\n\r\n  &.img-ssr,\r\n  &.img-loaded,\r\n  &.img-error {\r\n    // Reset background animation\r\n    &::before {\r\n      background: none;\r\n      animation: 0;\r\n    }\r\n  }\r\n\r\n  @keyframes animateBackground {\r\n    0%{\r\n      background-position: -468px 0\r\n    }\r\n\r\n    100%{\r\n      background-position: 468px 0\r\n    }\r\n  }\r\n}\r\n\r\n:host([animation=\"spinner\"]) {\r\n  --image-shell-spinner-size: 28px;\r\n  --image-shell-spinner-color: #CCC;\r\n\r\n  & > .spinner {\r\n    display: block;\r\n    position: absolute;\r\n    top: calc(50% - calc(var(--image-shell-spinner-size) / 2));\r\n    left: calc(50% - calc(var(--image-shell-spinner-size) / 2));\r\n    width: var(--image-shell-spinner-size);\r\n    height: var(--image-shell-spinner-size);\r\n    font-size: var(--image-shell-spinner-size);\r\n    line-height: var(--image-shell-spinner-size);\r\n    color: var(--image-shell-spinner-color);\r\n  }\r\n\r\n  &.img-ssr,\r\n  &.img-loaded,\r\n  &.img-error {\r\n    & > .spinner {\r\n      display: none;\r\n      visibility: hidden;\r\n    }\r\n  }\r\n}\r\n\r\n:host(.add-overlay) {\r\n  --image-shell-overlay-background: rgba(0, 0, 0, .4);\r\n\r\n  &.img-ssr,\r\n  &.img-loaded,\r\n  &.img-error {\r\n    // Add background overlay after the image has loaded\r\n    &::before {\r\n      display: block;\r\n      background: var(--image-shell-overlay-background);\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
